import { useState } from 'react';
import {
    incrementItemCart,
    findCartItem,
    filterCartItem,
    doCartTotal,
    findCartTotalQuantity
} from '../../../utils/cartUtils';

function useCartController(defaultValue = []) {
    const [cart, setCart] = useState(defaultValue);

    const addItemCart = item => {
        const found = findCartItem(item, cart);
        if (!found) return setCart([...cart, item]);
        const nextCart = incrementItemCart(cart, item);
        return setCart(nextCart);
    };

    const removeItemCart = item => {
        const nextCart = filterCartItem(item, cart);
        setCart(nextCart);
    };

    const handleItemChange = (nextQuantity, item) => {
        if (nextQuantity === 0) return removeItemCart(item);
        const nextCart = incrementItemCart(cart, item, nextQuantity);
        return setCart(nextCart);
    };

    const getCartTotal = () => doCartTotal(cart);

    const getCartQuantity = () => findCartTotalQuantity(cart);

    return {
        cart,
        addItemCart,
        removeItemCart,
        handleItemChange,
        getCartTotal,
        getCartQuantity
    };
}

export default useCartController;



// WEBPACK FOOTER //
// ./src/services/ebon/hooks/useCartController.js